import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

export const LandingHero: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-xs font-medium">
        <Sparkles className="w-3.5 h-3.5" />
        <span>Official Conversora Partner Program</span>
      </div>

      <div className="space-y-4">
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
          Earn 10%–20% Recurring Revenue with{' '}
          <span className="bg-linear-to-r from-indigo-400 to-violet-400 bg-clip-text text-transparent">
            Conversora Partners
          </span>
        </h1>
        <p className="text-sm sm:text-base text-zinc-400 max-w-xl mx-auto leading-relaxed">
          Help online merchants automate orders and customer support with Conversora AI.
          Earn predictable, monthly recurring commissions paid directly to your bKash, Nagad, or bank account.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
        <Link
          to="/sign-up"
          className="w-full sm:w-auto px-6 py-3 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-sm font-semibold transition flex items-center justify-center gap-2 shadow-lg shadow-indigo-600/25 cursor-pointer"
        >
          <span>Join Partner Program</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
        <Link
          to="/sign-in"
          className="w-full sm:w-auto px-6 py-3 bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 text-zinc-300 hover:text-white rounded-xl text-sm font-semibold transition flex items-center justify-center gap-2 cursor-pointer"
        >
          <span>Sign In to Portal</span>
        </Link>
      </div>
    </div>
  );
};
